/**
 * The role's case material, as shown on the board: a link, read-only.
 *
 * EDITING lives in the Edit panel modal (Theresa, Sep 2026). It used to be an
 * inline editor here, which meant a case was configured in two places — and the
 * original design was a file upload into Firebase Storage, which has never
 * worked in production: the deployed project-level rules carry no
 * `people_space/` block, this repo cannot deploy them, and the PR against
 * `finn-auto/spaces` that would have declared the path was closed unmerged.
 *
 * A link is not a lesser workaround. Every FINN case is shareable by URL, the
 * candidate can open it on any device, and no candidate-facing bytes pass
 * through the proxy or a recruiter's browser.
 */
import type { PanelConfig } from '../../types/taActionBoard';

type Material = NonNullable<PanelConfig['caseMaterial']>;

const label = (m: Material) => (m.kind === 'link' ? m.label : m.filename);
const href = (m: Material) => (m.kind === 'link' ? m.url : m.downloadUrl);

export function CaseMaterialRow({ material }: { material: PanelConfig['caseMaterial'] }) {
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-gray-600">
      <span className="font-semibold text-gray-800">Case material:</span>
      {material ? (
        <>
          <a
            href={href(material)}
            target="_blank"
            rel="noreferrer"
            className="text-[#0B4A87] hover:underline"
          >
            {label(material)}
          </a>
          <span className="text-gray-400">· sent with every slot proposal for this role</span>
        </>
      ) : (
        <span className="text-gray-400">none — add a link under “Edit panel”</span>
      )}
    </div>
  );
}
